import React from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '@/redux/slices/user';
import LogoutPanelStyled from './LogoutPanel.styled';
import { IconsDictionary } from '@/components/icon/Icon.types';
import Dropdown from '@/components/dropdown/Dropdown';
import { PanelTypes } from '@/types/Panel.types';
import useReadLocalStorage from '@/hooks/useReadLocalStorage';

interface LogoutPanePropsl {
  onClose: () => void;
}

const LogoutPanel = ({ onClose }: LogoutPanePropsl) => {
  const dispatch = useDispatch();
  const position = useReadLocalStorage('contensis-blocks-preview-toolbar-position');

  return (
    <LogoutPanelStyled data-position={position}>
      <Dropdown
        id={PanelTypes.Logout}
        defaultValue=""
        onClose={onClose}
        onDropdownSelect={() => {
          onClose();
          dispatch(actions.LOGOUT_USER());
        }}
        options={[
          {
            icon: IconsDictionary.Logout,
            id: 'log-out',
            label: 'Log out',
          },
        ]}
      />
    </LogoutPanelStyled>
  );
};

export default LogoutPanel;
